import { render, staticRenderFns } from "./ModeloPeca.vue?vue&type=template&id=2851f965&"
import script from "./ModeloPeca.vue?vue&type=script&lang=js&"
export * from "./ModeloPeca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports